/// <reference types="vite/client" />

export const API_ORIGIN: string =
    import.meta.env.VITE_API_ORIGIN || "https://api.ajsoftsolution.com";
